import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../core/models/contact-type.model'
import { MatCard } from '@angular/material/card'
import { MatButtonModule } from '@angular/material/button'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../shared/components/table-list/table-list.component'
import { ServiceOrderService } from '../../core/services/service/service-order/service-order.service'
import { convertCurrency } from '../../shared/utils/utils'
import { ProposalClientService } from '../../core/services/proposal/proposal-client/proposal-client.service'
import { ContractClientService } from '../../core/services/contract/contract-client/contract-client.service'
import { ScheduleFleetService } from '../../core/services/schedule/schedule-fleet/schedule-fleet.service'
import { ScheduleComponent } from '../../features/schedule/schedule.component'
import { MonitoringSearchComponent } from "./monitoring-search/monitoring-search.component";
import { FormGroup } from '@angular/forms'
import { TableListFixedComponent } from "../../shared/components/table-list-fixed/table-list-fixed.component";
import { MatPaginatorModule, PageEvent } from "@angular/material/paginator";
import { TableListMonitoringComponent } from "../../shared/components/table-list-monitoring/table-list-monitoring.component"
import { SnackbarCustomService } from '../../shared/components/snackbar/snackbar-custom.service'
import { ModalRecusarOperadorComponent } from '../../features/monitoring/modal-recusar-operador/modal-recusar-operador.component'
import { DialogConfirmComponent } from '../../shared/components/dialog-confirm/dialog-confirm.component'
import { ModalPassageirosOsComponent } from '../../features/monitoring/modal-passageiros-os/modal-passageiros-os.component'
import { ModalAssignDriverGestaoComponent, AssignDriverGestaoResult } from '../../features/monitoring/modal-assign-driver-gestao/modal-assign-driver-gestao.component'
import { ModalAssignVehicleGestaoComponent, AssignVehicleGestaoResult } from '../../features/monitoring/modal-assign-vehicle-gestao/modal-assign-vehicle-gestao.component'

@Component({
  selector: 'monitoring-component',
  imports: [
    MatCard,
    MatButtonModule,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    MonitoringSearchComponent,
    TableListFixedComponent,
    MatPaginatorModule,
    TableListMonitoringComponent
  ],
  templateUrl: './monitoring.component.html',
  styleUrl: './monitoring.component.scss',
  providers: [ServiceOrderService, AuthService],
  standalone: true,
})
export class MonitoringComponent implements OnInit {

  constructor(
    private proposalClientService: ProposalClientService,
    private contractClientService: ContractClientService,
    private scheduleFleetService: ScheduleFleetService,
    private serviceOrderService: ServiceOrderService,
    private authService: AuthService,
    private dialog: MatDialog,
    private snackbar: SnackbarCustomService,

  ) { }

  form!: FormGroup;
  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  inputSearch = ''

  // Fila do operador (status 12) — seleção em lote pra confirmar/recusar, mesmo padrão
  // usado em purchase-reservation-service-order.
  selectionMode = false
  selectedOsIds: string[] = []
  private readonly selectColumn = { keyColumn: 'select', key: 'select', description: '' }
  // Filtro em vigor (vem de monitoring-search) — reaplicado depois de confirmar/recusar
  // pra não resetar a busca do usuário.
  private lastSearchItem: any = null

  // Atribuição de motorista/veículo do fornecedor (FornecedorGestao) — mesmos perfis do
  // acompanhamento (1, 2, 3, 6); perfil 12 (fornecedor) usa o portal dele, não isso.
  private readonly PERFIS_GESTAO_FORNECEDOR = [1, 2, 3, 6]
  get canManageFornecedor(): boolean {
    const idPerfil = this.authService.getInfosObject()?.idPerfil
    return this.PERFIS_GESTAO_FORNECEDOR.includes(idPerfil)
  }

  columns: any[] = [
    // { keyColumn: 'code', key: 'id', description: 'Código' },
    {
      keyColumn: 'os_period',
      key: 'os_period',
      description: 'Periodo',
    },
    {
      keyColumn: 'os_code',
      key: 'os_code',
      description: 'Códigos',
    },
    {
      keyColumn: 'nomeCliente',
      key: 'nomeCliente',
      description: 'Cliente',
    },
    {
      keyColumn: 'os_percusent',
      key: 'os_percusent',
      description: 'Percurso',
    },
    {
      keyColumn: 'os_passengers',
      key: 'os_passengers',
      description: 'Passageiros',
    },
    {
      keyColumn: 'os_services',
      key: 'os_services',
      description: 'Serviços',
    },
    {
      keyColumn: 'os_vehicles',
      key: 'os_vehicles',
      description: 'Veículo',
    },
    {
      keyColumn: 'os_driver',
      key: 'os_driver',
      description: 'Motorista',
    },
    {
      keyColumn: 'nomeEvento',
      key: 'nomeEvento',
      description: 'Evento',
    },
    {
      keyColumn: 'status',
      key: 'descricaoStatus',
      description: 'Status',
    },
    {
      keyColumn: 'action',
      key: {
        edit: false, delete: false, view: true, confirmarOperador: true, recusarOperador: true,
        assignDriver: false, assignVehicle: false,
      },
      description: 'Ações',
      stickerEnd: true,
      width: '100px'
    },
  ]

  screen = 'status cotação'

  ngOnInit() {
    this.checkColumnAction()
    this.loading = true
    // this.getListItems()
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        // edit: this.checkPermission('editar'),
        delete: this.checkPermission('deletar'),
        view: true,
        confirmarOperador: true,
        recusarOperador: true,
        assignDriver: this.canManageFornecedor,
        assignVehicle: this.canManageFornecedor,
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  // search(event: any) {
  //   let search = event
  //   this.page = 1
  //   if (search) {
  //     this.searchForm.descricao = search
  //     this.searchListItems()
  //   } else {
  //     this.searchFleet(event)
  //   }
  // }

  pageChanged(page: number) {
    this.page = page
    // this.uploadList()
  }

  // uploadList(type: string = '') {
  //   if (type == 'new') {
  //     this.searchForm = new SearchContactTypeModel()
  //   }
  //   if (this.searchForm.descricao) {
  //     this.searchListItems()
  //   } else {
  //     this.searchFleet(type)
  //   }
  // }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.uploadList()
  }

  uploadList(type = '') {
    const item = this.createModel()
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      this.searchListItems()
    } else {
      this.searchFleet(item)
    }
  }

  listSearch(event: any) {
    this.loading = true
    if (event == null) {
      this.loading = false
      this.itemsList = []
      this.numberRows = 0
      this.loading = false

    } else if (event === 'reset') {
      const item = this.createModel()
      this.searchFleet(item)

    } else if (event && event !== 'reset') {
      this.searchFleet(event)
    } else {

      this.itemsList = event
      this.numberRows = event.length
      this.loading = false
    }
    //time para aguardar o retorno da api

  }



  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        // Verifica se o status da proposta é 'Pendente'


        list.push({
          ...item,
          valorTotalFormatado: `R$ ${convertCurrency(item.valorTotal)}`,
        })

        // if (item.statusPropostaDescricao === 'Pendente'){

        //   list.push({
        //     ...item,
        //     valorTotalFormatado: `R$ ${convertCurrency(item.valorTotal)}`,
        //   })
        // }
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  createModel() {


    return {

      dataInicio: null,
      dataFinal: null,
      nomeCliente: '',
      nomeSubCliente: '',
      statusIds: null,
      descricaoOrigem: '',
      descricaoDestino: '',
      descricaoTipoServico: '',
      servico: '',
      descricaoTipoVeiculo: '',
      descricaoTipoMotorista: '',
      codigoTg: '',
      codigoOs: '',
    }
  }

  searchFleet(item: any) {
    this.loading = true;
    this.lastSearchItem = item
    this.serviceOrderService.searchPagedAcompanhamento(this.page, this.rows, item).subscribe({
      next: (res) => {
        this.treatResponse(res)
        this.loading = false
      },
      error: (err) => {
        this.loading = false
      }
    })
    // this.scheduleDriverService.createAgendaMotorista(item).subscribe({
    //   next: (res) => {
    //     this.snackbar.success('Agendamento do motorista criado com sucesso')
    //     this.loading = false
    //     this.resetForm()
    //   },
    //   error: (err) => {
    //     console.error('Ocorreu um erro ao adicionar o agendamento do motorista', err)
    //     this.loading = false
    //   }
    // });
  }


  searchListItems() {
    this.loading = true
    this.scheduleFleetService
      .listPagedAgendaFrota(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => { },
        complete: () => {
          this.loading = false
        },
      })
  }



  viewItem(item: any) {
    const dialogRef = this.dialog.open(ScheduleComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { item, viewMode: true }


    })
    // dialogRef.componentInstance.responseViewEdit.subscribe((response: any) => {
    //   if (response) {
    //     this.searchFleet()
    //   }
    // })
    // dialogRef.afterClosed().subscribe(() => {
    //   this.searchFleet()
    // })
  }

  // downloadItem(item: any) {
  //   this.contractClientService.downloadContractClient(item.id).subscribe({
  //     next: (response: any) => {
  //       downloadBase64File(
  //         response.data.fileContent,
  //         response.data.fileName,
  //         response.data.type,
  //       )
  //     },
  //     error: (err: ResponseRequestModel) => {
  //       console.error(err)
  //     },
  //     complete: () => { },
  //   })
  // }

  deleteItem(item: any) {
  }

  viewPassengers(item: any) {
    this.dialog.open(ModalPassageirosOsComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      width: '900px',
      maxWidth: '95vw',
      data: { osId: item.codigoOs },
    })
  }

  assignDriver(item: any) {
    const dialogRef = this.dialog.open(ModalAssignDriverGestaoComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      width: '1000px',
      maxWidth: '95vw',
      data: { osId: item.codigoOs, fornecedorId: item.fornecedorId, nomeFornecedor: item.nomeFornecedor },
    })
    dialogRef.componentInstance.response.subscribe((result: AssignDriverGestaoResult) => {
      if (result.success) this.searchFleet(this.lastSearchItem ?? this.createModel())
    })
  }

  assignVehicle(item: any) {
    const dialogRef = this.dialog.open(ModalAssignVehicleGestaoComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      width: '1200px',
      maxWidth: '95vw',
      data: { osId: item.codigoOs, fornecedorId: item.fornecedorId, nomeFornecedor: item.nomeFornecedor },
    })
    dialogRef.componentInstance.response.subscribe((result: AssignVehicleGestaoResult) => {
      if (result.success) this.searchFleet(this.lastSearchItem ?? this.createModel())
    })
  }

  startSelection() {
    this.selectionMode = true
    this.selectedOsIds = []
    if (!this.columns.some((c) => c.keyColumn === 'select')) {
      this.columns = [this.selectColumn, ...this.columns]
    }
  }

  cancelSelection() {
    this.selectionMode = false
    this.selectedOsIds = []
    this.columns = this.columns.filter((c) => c.keyColumn !== 'select')
  }

  toggleSelectItem(item: any) {
    const index = this.selectedOsIds.indexOf(item.codigoOs)
    if (index === -1) {
      this.selectedOsIds.push(item.codigoOs)
    } else {
      this.selectedOsIds.splice(index, 1)
    }
  }

  toggleSelectAllItems(checked: boolean) {
    this.selectedOsIds = checked
      ? this.itemsList.filter((item: any) => item.status === 12).map((item: any) => item.codigoOs)
      : []
  }

  confirmarOperadorItem(item: any) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '400px',
      data: {
        title: 'Confirmar OS',
        message: `Confirmar a OS ${item.codigoOs}?`,
        confirmLabel: 'Confirmar',
      },
    })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (!confirmed) return
      this.serviceOrderService.confirmarOperador(item.codigoOs).subscribe({
        next: (res: any) => { this.handleOperadorResult(res, 'confirmada') },
        error: (err: any) => { this.snackbar.errorRequest(err) },
      })
    })
  }

  recusarOperadorItem(item: any) {
    const dialogRef = this.dialog.open(ModalRecusarOperadorComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      width: '500px',
      maxWidth: '95vw',
      data: { count: 1 },
    })
    dialogRef.afterClosed().subscribe((motivo: string | null) => {
      if (!motivo) return
      this.serviceOrderService.recusarOperador(item.codigoOs, motivo).subscribe({
        next: (res: any) => { this.handleOperadorResult(res, 'recusada') },
        error: (err: any) => { this.snackbar.errorRequest(err) },
      })
    })
  }

  confirmarSelecionadas() {
    if (this.selectedOsIds.length === 0) {
      this.snackbar.warning('Selecione ao menos uma OS.')
      return
    }
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '400px',
      data: {
        title: 'Confirmar OS',
        message: `Confirmar ${this.selectedOsIds.length} OS selecionada(s)?`,
        confirmLabel: 'Confirmar',
      },
    })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (!confirmed) return
      this.serviceOrderService.confirmarOperadorLote(this.selectedOsIds).subscribe({
        next: (res: any) => { this.handleOperadorResult(res, 'confirmada'); this.cancelSelection() },
        error: (err: any) => { this.snackbar.errorRequest(err) },
      })
    })
  }

  recusarSelecionadas() {
    if (this.selectedOsIds.length === 0) {
      this.snackbar.warning('Selecione ao menos uma OS.')
      return
    }
    const dialogRef = this.dialog.open(ModalRecusarOperadorComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      width: '500px',
      maxWidth: '95vw',
      data: { count: this.selectedOsIds.length },
    })
    dialogRef.afterClosed().subscribe((motivo: string | null) => {
      if (!motivo) return
      this.serviceOrderService.recusarOperadorLote(this.selectedOsIds, motivo).subscribe({
        next: (res: any) => { this.handleOperadorResult(res, 'recusada'); this.cancelSelection() },
        error: (err: any) => { this.snackbar.errorRequest(err) },
      })
    })
  }

  // Lote nunca falha por inteiro — trata aplicadas/ignoradas mesmo pra ações individuais
  // (que devolvem o mesmo formato, só com um item), como o backend recomendou.
  private handleOperadorResult(res: any, acao: 'confirmada' | 'recusada') {
    const aplicadas: string[] = res.data?.aplicadas ?? []
    const ignoradas: { ordemServicoId: string; motivo: string }[] = res.data?.ignoradas ?? []
    if (ignoradas.length === 0) {
      this.snackbar.success(`${aplicadas.length} OS ${acao}(s) com sucesso.`)
    } else if (aplicadas.length === 0) {
      this.snackbar.warning(`Nenhuma OS ${acao}. ${ignoradas.map((i) => `${i.ordemServicoId}: ${i.motivo}`).join(' | ')}`)
    } else {
      this.snackbar.warning(
        `${aplicadas.length} OS ${acao}(s). Ignoradas — ${ignoradas.map((i) => `${i.ordemServicoId}: ${i.motivo}`).join(' | ')}`,
      )
    }
    this.searchFleet(this.lastSearchItem ?? this.createModel())
  }
}
